import type { Filing } from '@/modules/tools/bankruptcy/stores/types'
import { formatNumber } from '@/utils'

export const PageBudget = ({ filing }: { filing: Filing }) => {
  const { numberOfPages, pageLimit: limit } = filing

  return (
    <span className="text-muted-foreground text-sm font-normal">
      ({formatNumber(numberOfPages)} of {formatNumber(limit)} pages used)
    </span>
  )
}
